import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["subtitle", "image", "modal"]

  open(event) {
    event.preventDefault()

    const params = event.params
    this.subtitleTarget.textContent = params.title || ""

    if (this.hasImageTarget) {
      this.imageTarget.src = params.imageSrc || ""
      this.imageTarget.alt = params.imageAlt || params.title || ""
    }

    this.syncDialogDescription()
    this.modalController.show(event)
  }

  get modalController() {
    return this.application.getControllerForElementAndIdentifier(this.modalTarget, "railsui-modal")
  }

  syncDialogDescription() {
    const container = this.modalTarget.querySelector("[data-railsui-modal-target='container']")
    if (!container) return

    const describedby = [this.subtitleTarget.id].filter(Boolean).join(" ")
    if (describedby) {
      container.setAttribute("aria-describedby", describedby)
    }
  }
}
